import { BsEnvelopeAt } from "react-icons/bs";

const InfoStep = ({
  email,
  onCancel,
  isLoading,
  onSendCode,
}: InfoStepProps) => (
  <div className="w-full space-y-4">
    <div className="bh-gray-7 rounded-[10px] p-4 bg-black justify-self-center">
      <BsEnvelopeAt className="text-2xl text-center text-white" />
    </div>
    <div className="space-y-2">
      <h1 className="text-2xl font-bold text-center text-gray-7">
        Verify Your Email
      </h1>
      <p className="text-gray-6 text-center">
        We'll send a verification code to {email || "your e-mail address"}.
        Click the button below to receive the code.
      </p>
    </div>
    <button
      type="button"
      onClick={onSendCode}
      disabled={isLoading}
      className="w-full px-4 py-2 text-white bg-gray-7 rounded-lg hover:bg-gray-6 focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isLoading ? "Sending..." : "Send Code"}
    </button>
    <button
      type="button"
      onClick={onCancel}
      className="w-full px-4 py-2 text-black rounded-lg border border-gray-7 hover:bg-gray-2 hover:text-white focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2"
    >
      Cancel
    </button>
  </div>
);

export default InfoStep;

interface InfoStepProps {
  email: string;
  isLoading: boolean;
  onSendCode: () => Promise<void>;
  onCancel: () => void;
}
